import {
    CLEAR_CLAIM_INFO_LINK_LIST,
    CLEAR_VEHICLE_LINK_LIST,
    END,
    SET_CLAIM_INFO_LINK_LIST,
    SET_ERROR_MESSAGE,
    SET_LOADING_MODAL_FLAG,
    SET_VEHICLE_LINK_LIST,
    VALIDATE_CLAIM_DATA,
    VALIDATE_REGEX,
} from './types';
import {
    ClearClaimInfoLinkListAction,
    ClearVehicleLinkListAction,
    EmptyAction,
    SetClaimInfoLinkListAction,
    SetErrorMessageAction,
    SetErrorMessagePayload,
    SetLoadingModalFlagAction,
    SetLoadingModalFlagPayload,
    SetVehicleLinkListAction,
    ValidateRegexAction,
    ValidateRegexPayload,
    ValidationAction,
    ValidationPayload,
} from './index';

export const end = (): EmptyAction => ({ type: END, payload: undefined });

/* CLAIMS */
export type BuildClearVehicleLinkList = () => ClearVehicleLinkListAction;
export const clearVehicleLinkList: BuildClearVehicleLinkList = () => ({
    type: CLEAR_VEHICLE_LINK_LIST,
    payload: undefined,
});
export type BuildClearClaimInfoLinkList = () => ClearClaimInfoLinkListAction;
export const clearClaimInfoLinkList: BuildClearClaimInfoLinkList = () => ({
    type: CLEAR_CLAIM_INFO_LINK_LIST,
    payload: undefined,
});
export type BuildSetErrorMessageAction = (payload: SetErrorMessagePayload) => SetErrorMessageAction;
export const setErrorMessage: BuildSetErrorMessageAction = (payload) => ({ type: SET_ERROR_MESSAGE, payload });

export type BuildSetVehicleLinkListAction = (payload: VehicleLink[]) => SetVehicleLinkListAction;
export const setVehicleLinkList: BuildSetVehicleLinkListAction = (payload) => ({
    type: SET_VEHICLE_LINK_LIST,
    payload,
});
export type BuildSetClaimInfoLinkListAction = (payload: ClaimInfoLink[]) => SetClaimInfoLinkListAction;
export const setClaimInfoLinkList: BuildSetClaimInfoLinkListAction = (payload) => ({
    type: SET_CLAIM_INFO_LINK_LIST,
    payload,
});
export const validateClaimData = (payload: ValidationPayload): ValidationAction => ({
    type: VALIDATE_CLAIM_DATA,
    payload,
});

export const validateRegex = (payload: ValidateRegexPayload): ValidateRegexAction => ({
    type: VALIDATE_REGEX,
    payload,
});
/* APP STATE */
export type BuiltSetLoadingModalFlagAction = (payload: SetLoadingModalFlagPayload) => SetLoadingModalFlagAction;
export const setLoadingModalFlagAction: BuiltSetLoadingModalFlagAction = (payload) => ({
    type: SET_LOADING_MODAL_FLAG,
    payload,
});
